module.exports = __webpack_public_path__ + "static/media/29DUNON11.f9f2ae99.jpg";